// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-work-public-scene {
  margin-top: 5rem;
}
.view-work-public-scene .head-menu {
  padding-top: 2.5rem;
}
.view-work-public-scene .naked-button-component button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.view-work-public-scene .naked-button-component button img {
  all: unset;
  padding-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/WorkScenes/ViewWorkPublicScene/index.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAKI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAHN;AAKM;EACE,UAAA;EACA,mBAAA;AAHR","sourcesContent":["@use '@Styles/variables';\n\n.view-work-public-scene {\n  margin-top: 5rem;\n\n  .head-menu {\n    padding-top: 2.5rem;\n  }\n\n  .naked-button-component {\n    button {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n\n      img {\n        all: unset;\n        padding-right: 1rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
